<div style="min-width: 448px;" class="h-100">
  @if ((state$ | async) === 'ready') {
    @if (renderedSignature$ | async) {
      <div class="card">
        <div class="card-header">
          Signature Preview
        </div>
        <div class="card-body bg-white">
          <p class="card-text justify-content-center" [innerHTML]="renderedSignatureSafe$ | async"></p>
        </div>
        <div class="card-footer text-center py-2">
          <button type="button" class="btn btn-primary" (click)="copyToClipboard()"><i class="fas fa-copy"></i> Copy to Clipboard</button>
        </div>
      </div>
    } @else {
      <div class="alert alert-secondary" role="alert">
        There is something wrong with the signature form. Please correct any errors to view rendered signature.
      </div>
    }
  }
  @if ((state$ | async) !== 'ready') {
    <tcc-loadingOverlay-signatures>Rendering Signature</tcc-loadingOverlay-signatures>
  }
</div>
